const ar = {
  home: 'Home',
  najizPortal: 'Najiz Portal',
  judicalEServices: 'The unified Judical electronic services',
  enter: 'Enter',
  noServicesFoundPleaseTryAgain: 'No services found.',
  new: 'New',
  modified: 'Modified',
  redirectToService: 'Redirect to Service',
  businessAccountActivationRequirements: 'The most important requirements for activating a business account',
  accountValidityPeriod: 'Account validity period',
  fromActivationDate: 'From activation date',
  accountCreationFees: 'Account creation fees',
  activateFirstOrganizationAccountText: 'Activate the first account of the organization',
  activateFirstOrganizationAccountDescription: 'Additional accounts will be charged.',
  fees: 'fees',
  free: 'free',
  sar: 'SAR',
  year: 'Year',

  verificationServices: {
    title: 'Verification services',
    description: 'This service enables you to verify documents issued by the Ministry of Justice electronically',
    userNeed: 'I want to check',
    browseVerificationServices: 'Browse verification services',
  },

  appInsights: {
    verificationServicesArName: 'Verification Services',
  },

  serviceUsage: 'Service usage',
  mostUsed: 'Most used',
  serviceExplaination: 'Service explaination',
  najizData: 'Najiz data',
  last7Days: 'last 7 days',
  najizDataDescription: 'The ideal solution for requesting reliable data and creating new business opportunities',
  najizDataLogin: 'Login to Najez Data',
  scrollMore: 'Scroll More',
  najizInNumbers: 'Najiz in numbers',

  services: {
    title: 'E-services',
    explaination: 'Service Explaination',
    browseAllServices: 'Browse all services',
    searchInServices: 'Search in services',
    prominentServices: 'Prominent Services',

  },

  licenseType: 'License type',
  chooseLicenseType: 'Choose license type',
  iWantToPreview: 'I want to preview',
  email: 'Email',
  withMaxLengthChars: 'Maximum {length} characters',

  contactWithUs: {
    title: 'Contact Us',
    slogan: 'We\'re here to serve you and you can contact us anytime',
    contactInsideKSA: 'Contact Us from Within the Kingdom',
    fromSunToThurs: 'Sunday to Thursday',
    fromInsideKSA: 'From Within the Kingdom of Saudi Arabia',
    contactUs: 'Contact Us',
    contactOutsideKSA: 'Call Us from Outside the Kingdom',
    contactTime: 'From 8 AM to 2:15 PM (Sunday - Thursday)',
    fromOutsideKSA: 'From Outside the Kingdom of Saudi Arabia',
    messageUs: 'Message Us',
    allWeekDays: 'All Days of the Week',
    allTheTime: 'All Times',
    instantChat: 'Instant Chat',
    chatWithUs: 'Chat with Us',
    pleaseToServeYou: 'We\'re happy to At your service at all Najiz centers.',
    najizCenterRiyadhBranch: 'Najiz Center, Riyadh Branch',
    najizCenterRiyadhBranchLocation: 'Anas Ibn Malik Road, Al Malqa, Riyadh 13524',
    location: 'Location',
    workingDays: 'Working Days',
    workingTime: 'Working Times',
    from: 'From',
    until: 'Until',
    atMorning: 'Amongst',
    atNight: 'Evening',
    najizCenterJeddahBranch: 'Najiz Center, Jeddah Branch',
    najizCenterJeddahBranchLocation: 'Sari, Al Khalidiyah District, Jeddah 23423',
    najizCenterDammamBranch: 'Najiz Center, Dammam Branch',
    najizCenterDammamBranchLocation: 'Dhahran-Jubail Expressway, Al Rawdah, Dammam',
    socialMediaAccounts: 'Social Media Accounts\' Social',
    x: 'X',
    instagram: 'Instagram',
    snapchat: 'Snapchat',
    youtube: 'YouTube',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    contactChannels: 'Channels for receiving inquiries and complaints',
    name: 'Name',
    enterTheName: 'Enter Name',
    email: 'Email',
    emailPlaceholder: 'Example@email.com',
    phone: 'Mobile Number',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'Message Subject',
    messageTitlePlaceholder: 'Enter Message Subject',
    messageCategory: 'Message Category',
    messageText: 'Message Text',
    theMessage: 'Message',
    send: 'Send',
    serviceAvailability: 'Service Availability',
    contactNumber: 'Contact Number',
    responseTime: 'Response Time',
    instant: 'Immediate',
    serviceType: 'Service Type',
    liveChat: 'Live Chat',
    inquiriesAndComplaints: 'Inquiries and Complaints',
    supportWithSignLanguage: 'Sign Language Support',
    tenDaysWork: '10 Working Days',
    twoWorkDays: 'Two Working Days',
    judicialContact: 'Judicial Communication',
    signSupport: 'Sign Support',
    question: 'Question',
    suggestion: 'Suggestion',
    help: 'Help',
    messageSentSuccessfully: 'Message Sent Successfully',
    contactSample: 'Contact Sample',
  },

  validations: {
    fieldIsRequired: 'This field is required',
    onlyNumbers: 'Please enter only numbers',
    maxInputsLength: 'The maximum number of inputs is {length}',
    numbersExactLength: 'The number of numbers must be {length}',
    startsWith: 'Must start with {listText}',
    phoneNumber: 'The mobile number must begin with {key} and be {length} numbers',
    emailAddress: 'Please enter a valid email address',
    onlyArabicAndNumbers: 'Please enter only Arabic letters and numbers.',
    onlyArabicOrNumbers: 'Please enter only Arabic letters or numbers.',
    specialCharacters: 'Please do not enter special characters.',
    twitterId: 'The username must be http(s)://twitter.com/xyz123',
    facebookId: 'The username must be http(s)://facebook.com/xyz123',
    minWordsLength: 'The minimum number of words must be {length}',
    theNameMustBeBinary: 'The name must be binary',
    onlyArabic: 'You must enter only Arabic characters',
    duplicatePhoneNumberInContactInfo: 'The number of the first person must not match the number of the second person',
    duplicatePhoneNumberInApplicantInfo: 'The mobile number must not match the mobile number in your personal information.',
    alphaNumeric: 'Please enter only English letters and numbers.',
    alphaNumericAndSpecialChars: 'Please enter English letters, numbers, and special characters such as {chars}.',
  },

  faqs: {
    title: 'Faqs',
    searchPlaceholder: 'Search here, for example: How to create a claim sheet',
    howCanWeHelpYou: 'How can we help you ?',
    browseAllQuestions: 'Browse all questions',
    noQuestionsAvailable: 'No questions available.',
    shareQuestion: 'Share question',
    questionLinkCopiedSuccessfully: 'Question link copied successfully',
    questionDetails: 'Question details',
    questionDetailsNotAvailable: 'Question details not available',
  },

  najizPartners: 'Najiz partners',

  contactUs: {
    title: 'Contact us',
    forMoreContacts: 'For more contacts',
  },
  mobileApplication: {
    title: 'Najiz app',
    downloadAvailability: 'You can download najiz app',
    devicesText: 'for smart devices that works with android and iphon os',
  },

  useTheService: 'Use the service',
  startTheService: 'Start the Service',
  serviceDescription: 'Service description',
  serviceRequirements: 'Service requirements',
  stepsToApplyForTheService: 'Steps to apply for the service',
  submitNewRequest: 'Submit a new request',
  followUpOnPreviousRequest: 'Follow up on previous request',
  authenticationOfCompletedRequest: 'Authentication of completed request',
  serviceVideoExplaination: 'Service video explaination',
  serviceProviderChannels: 'Service provider channels',
  youShouldKnow: 'You should know',
  fetchingData: 'Fetching data in progress ...',
  searchResult: 'Search result',
  searchResults: 'Search results ({searchText})',
  browseService: 'Browse service',
  noSearchResultsFound: 'There are no results matching the data entered',
  noSearchResultsMessage: 'Please verify the data and try again.',

  login: 'Login',
  activateBusinessAccount: 'Activate business account',
  individuals: 'Individuals',
  businesses: 'Businesses',
  government: 'Government',
  lawyers: 'Lawyers',
  individualsLoginMsg: 'Login for individuals including citizens, residents and visitors',
  businessesLoginMsg: 'Login for owners and representatives of companies, institutions and public benefit facilities',
  governmentLoginMsg: 'Login for representatives of government agencies',
  lawyersLoginMsg: 'Login for lawyers licensed by the Ministry of Justice',
  forMoreDetails: 'For more details',
  requiredDocuments: 'Required documents',
  serviceExecutionTime: 'Service execution time',
  instant: 'Instant',
  serviceExecutionTimeDescription: 'From {from} - To {to}',
  beneficiaries: 'beneficiaries',
  serviceFees: 'Service fees',
  commonFaqs: 'Common faqs',
  checkFaqs: 'Check faqs',
  clickHere: 'Click here',
  signalSupport: 'Signal support',
  signalCustomerSupport: 'Signal customer support',
  allServices: 'All services',
  downloadApp: 'Download app',
  usageGuide: 'Usage guide',
  downloadUsageGuide: 'Download usage guide',
  theDescription: 'The description',
  theRequirements: 'The requirements',
  theSteps: 'The steps',
  share: 'share',
  serviceLinkCopiedSuccessfully: 'Service link copied successfully',
  loginToCreateAccount: 'login to create account',

  sessionsAttendence: 'attending sessions',
  ePayment: 'electronic payment',
  executionRequestActions: 'Actions on execution request',
  virtualCourtExecutionRequest: 'Virtual Court Execution Request',
  nowFromApp: 'Now From App',
  downloadAppNow: 'Download Najiz App Now',

  serverErrors: {
    USER_NOT_FOUND: 'User is not found, please try again',
    INVALID_DATA: 'INVALID DATA, please try again',
    SERVER_ERROR: 'Something went wrong, please try again later',
  },
};

export default ar;
